import { css } from 'styled-components';

import { Theme } from '../../../theme';

const getInputIconStyles = (theme: Theme, isDisabled: boolean = false) => {
  const variant = theme.components.Input.regular.big;

  return css`
    flex-grow: 0;
    flex-shrink: 0;
    width: ${theme.core.iconSize.m};
    height: ${theme.core.iconSize.m};
    fill: ${isDisabled ? variant['icon-disabled'] : variant['icon-default']};
  `;
};

export default getInputIconStyles;
